import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../reducers';
import { TOKEN_KEY } from '../constants';
import { setAuthData } from '../reducers/authReducer';

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;

const token = localStorage.getItem(TOKEN_KEY);
if (token) {
  store.dispatch(setAuthData());
}

export default store;
